import { render } from "./FormSuccess.vue?vue&type=template&id=57972a8f&scoped=true"
import script from "./FormSuccess.vue?vue&type=script&lang=js"
export * from "./FormSuccess.vue?vue&type=script&lang=js"

import "./FormSuccess.vue?vue&type=style&index=0&id=57972a8f&scoped=true&lang=css"

import exportComponent from "D:\\Java Script Udemy Kurs\\VUE COURSE\\vue-form\\vue-form\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57972a8f"]])

export default __exports__